module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=1.24"},{"quantity":0.03,"color":"#91E3AD","label":"1.24 - 1.8"},{"quantity":0.06,"color":"#DEFFB0","label":"1.8 - 2.53"},{"quantity":0.01,"color":"#FFE68C","label":"2.53 - 3.46"},{"quantity":9,"color":"#FF9982","label":"3.46 - 4.9"},{"quantity":12,"color":"#FF4D30","label":"4.9 - 1.024"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_90_maize.json
// module id = /Led
// module chunks = 171